import { AnimalIcon, BlanketIcon, BooksIcon, GameControllerIcon, GuitarIcon, HoodieIcon, PhoneCaseIcon, PillowIcon, SmileyFaceIcon, SportsIcon, StickersIcon, TshirtIcon, TvIcon, VideoCameraIcon, WallArtIcon, } from './icons';
import { messages } from './messages';
export function buildTopicNavConfig(formatMessage) {
    return {
        topics: {
            href: '/shop/',
            label: formatMessage(messages.seeAllTopics),
            // anime intentionally omitted (categoryConfig flags it "remove before release").
            items: [
                {
                    slug: 'music',
                    label: formatMessage(messages.music),
                    icon: GuitarIcon,
                },
                {
                    slug: 'television',
                    label: formatMessage(messages.television),
                    icon: TvIcon,
                },
                {
                    slug: 'movies',
                    label: formatMessage(messages.movies),
                    icon: VideoCameraIcon,
                },
                {
                    slug: 'animals',
                    label: formatMessage(messages.animals),
                    icon: AnimalIcon,
                },
                {
                    slug: 'gaming',
                    label: formatMessage(messages.gaming),
                    icon: GameControllerIcon,
                },
                {
                    slug: 'sports',
                    label: formatMessage(messages.sports),
                    icon: SportsIcon,
                },
                {
                    slug: 'funny',
                    label: formatMessage(messages.funny),
                    icon: SmileyFaceIcon,
                },
                {
                    slug: 'books',
                    label: formatMessage(messages.books),
                    icon: BooksIcon,
                },
            ],
        },
        products: {
            href: '',
            label: formatMessage(messages.seeAllProducts),
            items: [
                {
                    slug: 't-shirts',
                    label: formatMessage(messages.tShirts),
                    icon: TshirtIcon,
                },
                {
                    slug: 'stickers',
                    label: formatMessage(messages.stickers),
                    icon: StickersIcon,
                },
                {
                    slug: 'prints',
                    label: formatMessage(messages.wallArt),
                    icon: WallArtIcon,
                },
                {
                    slug: 'blankets',
                    label: formatMessage(messages.blankets),
                    icon: BlanketIcon,
                },
                {
                    slug: 'sweatshirts',
                    label: formatMessage(messages.hoodies),
                    icon: HoodieIcon,
                },
                {
                    slug: 'throw-pillows',
                    label: formatMessage(messages.pillows),
                    icon: PillowIcon,
                },
                {
                    slug: 'iphone-cases',
                    label: formatMessage(messages.phoneCases),
                    icon: PhoneCaseIcon,
                },
            ],
        },
    };
}
